import { normalizeLegacyMediaUrl } from '../../utils/mediaUrl';

const IMG_STORAGE = (process.env.REACT_APP_IMG_STORAGE || '').replace(/\/+$/, '');
const CMS_ORIGIN = (process.env.REACT_APP_CMS_ORIGIN || IMG_STORAGE.replace(/\/public\/?$/, '')).replace(/\/+$/, '');
const AMAZON_STORAGE = process.env.REACT_APP_AMAZON_BUCKET;

function resolveStorageUrl(path, subfolder = '') {
  if (!path) {
    return '';
  }
  const normalized = normalizeLegacyMediaUrl(path);
  if (/^https?:\/\//i.test(normalized)) {
    return normalized;
  }
  if (normalized.startsWith('/storage/')) {
    return `${CMS_ORIGIN}${normalized}`;
  }
  const clean = String(normalized).replace(/^\//, '');
  const prefix = subfolder ? `${subfolder}/` : '';
  return `${IMG_STORAGE}/${prefix}${clean}`;
}

export function getProfileImageUrl(imagePath) {
  if (!imagePath) {
    return '';
  }
  const path = String(imagePath);
  if (
    /^https?:\/\//i.test(path)
    || path.startsWith('data:')
    || path.startsWith('/static/')
    || path.includes('/assets/')
    || path.includes('/static/media/')
  ) {
    return normalizeLegacyMediaUrl(path);
  }
  return resolveStorageUrl(imagePath);
}

export function getLabelImageUrl(imagePath) {
  const normalized = normalizeLegacyMediaUrl(imagePath);
  if (/^https?:\/\//i.test(normalized) || String(normalized).startsWith('/storage/')) {
    return resolveStorageUrl(normalized);
  }
  return resolveStorageUrl(imagePath, 'labels_pictures');
}

export function getProductCoverUrl(imagePath) {
  return `${AMAZON_STORAGE}/product/coverProducts/${imagePath}`;
}

export function getAudioFile(audioFilePath) {
  return resolveStorageUrl(audioFilePath, 'product/asset');
}

export function getDspImageUrl(imagePath) {
  return resolveStorageUrl(imagePath, 'dsp_pictures');
}
